import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TaskService } from '../../../../../shared/service/task.service';
import { SignaturePad } from 'angular2-signaturepad';
import {InternalDocument} from '../../../../../shared/model/internal-document';
import {DocumentService} from '../../../../../shared/service/document.service';

@Component({
  selector: 'app-supplier-contract-task',
  templateUrl: './supplier-contract-task.component.html',
  styleUrls: ['./supplier-contract-task.component.scss']
})
export class SupplierContractTaskComponent implements OnInit, AfterViewInit, OnDestroy {

  taskForm: FormGroup;
  fileList: InternalDocument[] = [];

  @Input() editable: boolean;
  @Input() taskId: number;
  @Input() invalidationReason: string;

  public signaturePadOptions = {
    minWidth: 2,
    canvasHeight: 300
  };
  public signatureCheckBoxText = 'Sunt de acord ca semnatura de mai sus sa fie reprezentarea digitala a propriei semnaturi si sa fie utilizata in toate cazurile cand va fi nevoie sa semnez documentele din cadrul procesului de Contractare. Aceasta semnatura va avea aceeasi valoare ca semnatura olografa, pe hartie.';

  @ViewChild('signatureDiv') signatureDiv: ElementRef;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.handleSignatureCanvasSize();
  }

  constructor(
    public documentService: DocumentService,
    private formBuilder: FormBuilder,
    private taskService: TaskService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.createTaskForm();
    this.taskService.getTask(this.taskId).subscribe((task) => this.initializeFormFields(task));
  }

  ngAfterViewInit(): void {
    this.handleSignatureCanvasSize();
  }

  handleSignatureCanvasSize(): void {
    const canvas = document.querySelector('canvas');
    if (canvas && this.signatureDiv) {
      const tempWidth = String(this.signatureDiv.nativeElement.clientWidth);
      const widthCanvas = tempWidth.concat('px');
      canvas.setAttribute('width', widthCanvas);
    }
  }

  initializeFormFields(task: any): void {
    console.log('task', task);
    const effectiveDate = new Date(task.information.startingDate);
    const expirationDate = new Date(effectiveDate.getUTCFullYear() + 1, effectiveDate.getUTCMonth(), effectiveDate.getUTCDate());
    this.taskForm.patchValue({
      taskNumber: task.id,
      taskName: task.name,
      supplierContractNumber: task.information.number,
      supplierContractDate: task.information.date,
      networkContractNumber: task.information.contractNetworkNumber,
      networkContractDate: task.information.contractNetworkDate,
      conventionNumber: '',
      conventionDate: '',
      effectiveDate: task.information.startingDate,
      expirationDate: task.information.expirationDate
    });

    if (this.invalidationReason) {
      this.taskForm.controls.invalidationReason.setValue(this.invalidationReason);
    }
    for (const field of Object.keys(this.taskForm.controls)) {
      const control = this.taskForm.get(field);
      control.disable();

      if (this.editable && (
        field === 'requestValidated' ||
        field === 'invalidationReason' ||
        field === 'signatureCheckBox'
      )) {
        control.enable();
      }
    }
    const documents: InternalDocument[] = task.information.documents;
    if (documents && documents.length > 0) {
      const reducedDocuments = documents.reduce((acc: InternalDocument[], document) => {
        const existing = acc.find((d) => d.fileName === document.fileName);
        if (existing) {
          const dt = document.timestamp || new Date(0);
          const existingDt = existing.timestamp || new Date(0);
          if (dt > existingDt) {
            acc = acc.map((d) => d.fileName === document.fileName ? document : d);
          }
        } else {
          acc.push(document);
        }

        return acc;
      }, [] as InternalDocument[]);
      this.fileList = reducedDocuments;
    }
    this.changeDetectorRef.detectChanges();
  }

  createTaskForm(): void {
    this.taskForm = this.formBuilder.group({
      taskNumber: [''],
      taskName: [''],
      supplierContractNumber: [''],
      supplierContractDate: [''],
      networkContractNumber: [''],
      networkContractDate: [''],
      conventionNumber: [''],
      conventionDate: [''],
      requestValidated: [''],
      invalidationReason: [''],
      effectiveDate: [''],
      expirationDate: [''],
      signatureCheckBox: ['']
    });
  }

  setRequestValidated(value: boolean): void {
    this.taskForm.controls.requestValidated.setValue(value);
  }

  onSubmit(): void {
    if (!!this.taskForm.get('requestValidated').value) {
      this.taskService.resolveTaskFurnizorSemnatura(this.taskId, {
        signature: this.signaturePad.toDataURL()
      })
        .subscribe(() => {
          history.back();
        });
    } else {
      this.taskService.resolveTaskFurnizorMotiv(this.taskId, this.taskForm.get('invalidationReason').value).subscribe(() => {
        history.back();
      });
    }
  }

  ngOnDestroy(): void {
  }

}
